import React, { useState } from 'react';
import styles from './WholesalerFBM.module.scss';
import { Button, Col, Container, Input, Label, Row } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from 'react-router-dom';
import { benefits, columns, customStyles, data, formFields, steps } from './fbmData';
import { GoCheckCircleFill } from "react-icons/go";
import { useDispatch } from 'react-redux';
import { setApproved } from '../../../utility/api/services/fbmApprovalSlice/approvalFbmSlice';

const FBM = () => {
    const [isRegistered, setIsRegistered] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleRegisterFBM = () => {
        setIsRegistered(true);

        setTimeout(() => {
            dispatch(setApproved(true));
            navigate("/fbm/dashboard");
        }, 2000);
    };

    return (
        <div className={styles.mainFBMContainer}>
            {isRegistered ? (
                <Container fluid className={styles.registeredContainer}>
                    <Row className={styles.registeredRow}>
                        <Col className="text-center p-0">
                            <div className={styles.checkIcon}>
                                <GoCheckCircleFill size={140} color="#EC7426" />
                            </div>
                            <h5 className={styles.registeredMessage}>
                                Thank you for registering for Fulfilled by Maelano (FBM)!
                            </h5>
                            <p>
                                Our team will review your application and contact you within 2-3 business days. Once
                                approved, you'll receive instructions on how to start sending your inventory to our warehouses.
                            </p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <div>
                    <h4 className={styles.mainHeading}>Fulfilled by Maelano (FBM)</h4>

                    <Container fluid className={styles.fbmHeaderText}>
                        <p>
                            Join Fulfilled by Maelano (FBM) to streamline your order fulfillment process. Our service handles
                            storage, packaging, and shipping, allowing you to focus on growing your business. Enjoy faster shipping,
                            higher customer satisfaction, and more time to manage your products.
                        </p>
                    </Container>

                    <h5 className={styles.sectionHeading}>Benefits of Fulfilled by Maelano</h5>

                    <Container fluid className={styles.listContainer}>
                        <ul>
                            {benefits.map((benefit, index) => (
                                <li key={index}>
                                    <span>{benefit.heading}:</span> {benefit.content}
                                </li>
                            ))}
                        </ul>
                    </Container>

                    <h5 className={styles.sectionHeading}>Step-by-Step Process</h5>

                    <Container fluid className={styles.listContainer}>
                        <ol>
                            {steps.map((benefit, index) => (
                                <li key={index}>
                                    <span>{benefit.heading}:</span> {benefit.content}
                                </li>
                            ))}
                        </ol>
                    </Container>

                    <h5 className={styles.sectionHeading}>Pricing and Fees</h5>

                    <Container fluid className={styles.mainTableContainer}>
                        <div className={styles.dataTableContainer}>
                            <DataTable
                                title={"Following is the FBM pricing structure"}
                                columns={columns}
                                data={data}
                                highlightOnHover
                                customStyles={customStyles}
                            />
                        </div>
                    </Container>

                    <h4 className={styles.mainHeading}>Sign Up for FBM</h4>

                    <Container fluid className={styles.signUpContainer}>
                        <div className={styles.sectionTitle}>
                            <h5 className={styles.sectionSubHeading}>Registration Form</h5>
                        </div>

                        <div className={styles.registrationForm}>
                            {formFields.map((field, index) => (
                                <Row key={index} className={styles.formGroupRow}>
                                    <Col lg={3} xxl={2}>
                                        <Label for={field.id}>{field.label}:</Label>
                                    </Col>
                                    <Col lg={field.type === "textarea" ? 9 : 5} xxl={field.type === "textarea" ? 10 : 4}>
                                        {field.type === "select" ? (
                                            <Input type="select" id={field.id} defaultValue="">
                                                <option value="" disabled>Select {field.label}</option>
                                                {field.options.map((option, idx) => (
                                                    <option key={idx} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </Input>
                                        ) : (
                                            <Input type={field.type} id={field.id} placeholder={field.placeholder} />
                                        )}
                                    </Col>
                                </Row>
                            ))}
                            <Row className={styles.checkBoxRow}>
                                <Col lg={"auto"} className={styles.termsSection}>
                                    <Input type="checkbox" id="termsCheckbox" />
                                    <Label for="termsCheckbox">
                                        I agree with the Terms and Conditions for FBM
                                    </Label>
                                </Col>
                                <Col className="text-end text-lg-start">
                                    <p className={styles.termsConditions}>
                                        Read <Link to="/sellerterms" target="_blank" rel="noopener noreferrer">Terms and Conditions</Link>
                                    </p>
                                </Col>
                            </Row>
                        </div>
                        <div className={styles.registerBtnContainer}>
                            <Button
                                type="button"
                                color="primary"
                                className={styles.registerBtn}
                                onClick={handleRegisterFBM}
                            >
                                Register
                            </Button>
                        </div>
                    </Container>
                </div>
            )}
        </div>
    );
};

export default FBM;